import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const ProductWrapper = styled.div`
  text-align: center;
  padding: 8px 28px 24px;
  border: 1px solid ${props => props.theme.palette.general.strong};
  box-shadow: inset 0 0 0 6px ${props => props.theme.palette.general.greyLight};
  margin-bottom: 30px;

  .product {
    &-image {
      display: block;
    }

    &-name {
      color: ${props => props.theme.palette.general.strong};
      font: ${font('alt', 'normal', '35px/1.2')};
      font-size: clamp(1.56rem, 2vw, 2.5rem);
      text-decoration: none;
    }

    &-price {
      margin: 15px 0 12px;

      p {
        margin-bottom: 0;
        font-size: 18px;
      }

      span.regularPrice {
        font: ${font('default', 'bold', '24px/1.2')};
        color: ${props => props.theme.palette.general.strong};
      }
    }
  }

  button {
    margin: auto;
    padding: 10px 24px;
    font: ${font('alt', 'normal', '24px/1.2')};
    font-size: clamp(1.125rem, 2.2vw, 1.5rem);
    box-shadow: 0 7px 14px rgba(0, 0, 0, 0.15), 0 5px 5px rgba(0, 0, 0, 0.12);
    transition: box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

    &:hover {
      box-shadow: 0 10px 18px rgba(0, 0, 0, 0.15), 0 9px 9px rgba(0, 0, 0, 0.12);
    }

    > div {
      padding: 0;
    }
  }
`
